export const CSS_CLASSES = {
    // Layout Builder
    LAYOUT_BUILDER: 'layout-builder',
    
    // Container Classes
    PROPERTY_CONTAINER: 'property-container',
    VIEWPORT_CONTAINER: 'viewport-container',
    LAYER_PROPERTY_CONTAINER: 'layer-property-container',
    DRAGGABLE_CONTAINER: 'draggable-container',
    PROPERTY_PANEL_CONTAINER: 'property-panel-container',
    
    // Panel Classes
    PROPERTY_PANEL: 'property-panel',
    PAGE_PROPERTY_Container: 'page-property-container',
    TOOLBOX_PANEL: 'toolbox-panel',
    LAYER_PANEL: 'layer-panel',
    
    // Section Classes
    SECTION: 'section',
    IMAGE_SECTION: 'image-section',
    LOCKED: 'locked',
    
    // Item Classes
    LAYOUT_DRAG_ITEM: 'layout-drag-item',
    TOOLBOX_DRAG_ITEM: 'toolbox-drag-item',
    
    // Alignment Classes
    ALIGNMENT_LINE: 'alignment-line',
    HORIZONTAL_LINE: 'horizontal-line',
    VERTICAL_LINE: 'vertical-line',
    
    // Resize Classes
    RESIZE_HANDLE: 'resize-handle',
    RESIZE_TOP_LEFT: 'top-left',
    RESIZE_TOP_RIGHT: 'top-right',
    RESIZE_BOTTOM_LEFT: 'bottom-left',
    RESIZE_BOTTOM_RIGHT: 'bottom-right',
    
    // State Classes
    SELECTED: 'selected',
    
    // Field Classes
    PROPERTY_FIELD: 'property-field',
    
    // Rich Text Editor Classes
    WRAPPER: 'wrapper',
    RICH_TEXT_SECTION: 'rich-text-section',
    EDIT_ICON: 'edit-icon',
    EDITOR_DIALOG: 'editor-dialog',
    EDITOR_CONTAINER: 'editor-container',
    
    // Component IDs
    ID: {
        VIEWPORT_CONTAINER: 'viewport-container',
        LAYOUT_BUILDER: 'layout-builder',
        VIEWPORT: 'viewport',
        SCREENSIZE_CONTAINER: 'screensize-container',
        SCREENSIZE_ADAPTOR: 'screensize-adaptor',
        TOOLBOX: 'toolbox',
        PROPERTY_CONTAINER: 'property-container',
        LAYER_PROPERTY_CONTAINER: 'layer-property-container',
        SIDEBAR: 'sidebar'
    }
} as const;


export const SELECTORS ={
  SELECTED_DRAG_ITEM:`.${CSS_CLASSES.LAYOUT_DRAG_ITEM}.${CSS_CLASSES.SELECTED}`,
  TOOLBOX_DRAG_ITEM: `.${CSS_CLASSES.TOOLBOX_DRAG_ITEM}`,
  DRAGGABLE_CONTAINER:`.${CSS_CLASSES.DRAGGABLE_CONTAINER}`,
  SELECTED:`.${CSS_CLASSES.SELECTED}`,
  SECTION:`.${CSS_CLASSES.SECTION}`,
  LAYOUT_DRAG_ITEM:`.${CSS_CLASSES.LAYOUT_DRAG_ITEM}`,
  RICH_TEXT_SECTION: `.${CSS_CLASSES.RICH_TEXT_SECTION}`,
  EDITOR_DIALOG: `.${CSS_CLASSES.EDITOR_DIALOG}`,
  EDITOR_CONTAINER: `.${CSS_CLASSES.EDITOR_CONTAINER}`, 
  VIEWPORT: `#${CSS_CLASSES.ID.VIEWPORT}`,
  VIEWPORT_CONTAINER: `#${CSS_CLASSES.ID.VIEWPORT_CONTAINER}`,
  LOCKED_DRAG_ITEM: `.${CSS_CLASSES.LAYOUT_DRAG_ITEM}.${CSS_CLASSES.LOCKED}`,
  UNLOCKED_DRAG_ITEM: `.${CSS_CLASSES.LAYOUT_DRAG_ITEM}:not(.${CSS_CLASSES.LOCKED})`,
  SELECTED_LOCKED_DRAG_ITEM:`.${CSS_CLASSES.LAYOUT_DRAG_ITEM}.${CSS_CLASSES.SELECTED}.${CSS_CLASSES.LOCKED}`,
  SELECTED_UNLOCKED_DRAG_ITEM:`.${CSS_CLASSES.LAYOUT_DRAG_ITEM}.${CSS_CLASSES.SELECTED}:not(.${CSS_CLASSES.LOCKED})`,
} as const;